import useMediaQuery from '@cannect/hooks/useMediaQuery'
import { MOBILE_WIDTH } from '@cannect/utils/constants'
import React from 'react'
import styled from 'styled-components'
import { formatReal } from 'utils/formatters'

interface OrderSummaryProps {
  items: any[]
  discountFreight: number
  discountProduct: number
  freight: number
  reshipping_value: number
  subtotal: number
  amount: number
  originType: string
  payments: any[]
  noImportCost: boolean
  nationalFreight?: number
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
  items,
  discountFreight,
  discountProduct,
  freight,
  reshipping_value,
  subtotal,
  amount,
  originType,
  payments,
  noImportCost,
  nationalFreight
}) => {
  const totalAmount = Number(amount) + Number(discountProduct) - Number(freight)
  const subtotalAmount = Number(subtotal) - Number(freight)
  const freightAmount = Number(freight) + Number(discountFreight)

  const isMobile = useMediaQuery(MOBILE_WIDTH)
  return (
    <SummaryContainer>
      <SummaryTitle>Resumo do Pedido</SummaryTitle>
      {/* <SummaryProducts>
        {!isMobile && (
          <SummaryHeader>
            <HeaderItem>Produto</HeaderItem>
            <HeaderItem>Quantidade</HeaderItem>
            <HeaderItem>Sabor</HeaderItem>
            <HeaderItem>Valor Unitário</HeaderItem>
            <HeaderItem>Valor Total</HeaderItem>
          </SummaryHeader>
        )}
        {items.map((item) => (
          <SummaryProduct key={item.id} isMobile={isMobile}>
            <ProductInfo>
              <SummaryProductImage src={item.product?.media[0]?.path} alt={item.name} />
              <SummaryProductName>{item.product?.translated_name}</SummaryProductName>
            </ProductInfo>
            {isMobile ? (
              <MobileProductDetails>
                <MobileDetailRow>
                  <span>Quantidade:</span>
                  <span>{item.quantity}</span>
                </MobileDetailRow>
                <MobileDetailRow>
                  <span>Sabor:</span>
                  <span>{item.product?.flavor || 'Natural'}</span>
                </MobileDetailRow>
                <MobileDetailRow>
                  <span>Valor Unitário:</span>
                  <span>
                    {item.promotional && (
                      <>
                        <DiscountValue>-{Number(item.promotion.discount_value).toFixed(0)}%&nbsp;</DiscountValue>
                        <StrikedPrice>{formatReal(item.promotion.regular_price)}</StrikedPrice>
                        &nbsp;
                      </>
                    )}
                    {formatReal(item.promotional ? item.promotion.promotional_price : item.product?.real_price)}
                  </span>
                </MobileDetailRow>
                <MobileDetailRow>
                  <span>Valor Total:</span>
                  <ProductTotalPrice>{formatReal(item.amount)}</ProductTotalPrice>
                </MobileDetailRow>
              </MobileProductDetails>
            ) : (
              <>
                <ProductQuantity>{item.quantity}</ProductQuantity>
                <ProductFlavor>{item.product?.flavor || 'Natural'}</ProductFlavor>
                <ProductUnitPrice>
                  {item.promotional && (
                    <OldPrice>
                      <DiscountValue>-{Number(item.promotion.discount_value).toFixed(0)}% </DiscountValue>
                      <StrikedPrice>{formatReal(item.promotion.regular_price)}</StrikedPrice>
                    </OldPrice>
                  )}
                  {formatReal(item.promotional ? item.promotion.promotional_price : item.product?.real_price)}
                </ProductUnitPrice>
                <ProductTotalPrice>{formatReal(item.amount)}</ProductTotalPrice>
              </>
            )}
          </SummaryProduct>
        ))}
      </SummaryProducts> */}

      <SummaryContent isMobile={isMobile}>
        {originType !== 'REENVIO' && (
          <>
            <SummaryRow isMobile={isMobile}>
              <span>Produtos</span>
              <span>{formatReal(totalAmount)}</span>
            </SummaryRow>
            <SummaryRow isMobile={isMobile}>
              <span>Desconto nos produtos</span>
              <span>- {formatReal(discountProduct ?? 0)}</span>
            </SummaryRow>
            <SummaryRow isMobile={isMobile}>
              <span>Subtotal</span>
              <span>{formatReal(subtotalAmount)}</span>
            </SummaryRow>
            {!noImportCost && (
              <SummaryRow isMobile={isMobile}>
                <span>Custo de importação</span>
                <span>{formatReal(freightAmount)}</span>
              </SummaryRow>
            )}
            {!noImportCost && (
              <SummaryRow isMobile={isMobile}>
                <span>Desconto no custo de importação</span>
                <span>- {formatReal(discountFreight)}</span>
              </SummaryRow>
            )}
          </>
        )}
        {nationalFreight > 0 && (
          <SummaryRow isMobile={isMobile}>
            <span>Frete nacional</span>
            <span>{formatReal(nationalFreight)}</span>
          </SummaryRow>
        )}
        {reshipping_value > 0 && (
          <SummaryRow isMobile={isMobile}>
            <span>Taxa de reenvio</span>
            <span>{formatReal(reshipping_value)}</span>
          </SummaryRow>
        )}
        <TotalRow isMobile={isMobile}>
          <span>{originType === 'REENVIO' ? 'Total do Reenvio' : 'Total'}</span>
          <span>{formatReal(amount)}</span>
        </TotalRow>
      </SummaryContent>
    </SummaryContainer>
  )
}

const SummaryContainer = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
`

const SummaryTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1c1c1c;
  margin-bottom: 16px;
`

const SummaryContent = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: ${({ isMobile }) => (isMobile ? '24px' : '0')};
`

const SummaryRow = styled.div<{ isMobile?: boolean }>`
  display: flex;
  justify-content: space-between;
  color: #4a4a4a;
  font-size: ${({ isMobile }) => (isMobile ? '13px' : '14px')};
`

const TotalRow = styled(SummaryRow)`
  font-size: 18px;
  font-weight: 600;
  color: #1c1c1c;
  border-top: 1px solid #e5e5e5;
  padding-top: 12px;
  margin-top: 8px;
`

const SummaryProducts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
`

const SummaryHeader = styled.div`
  display: grid;
  grid-template-columns: 3fr 0.8fr 1fr 1fr 1fr;
  gap: 24px;
  padding: 12px 0;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 12px;
`

const HeaderItem = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #4a4a4a;
`

const SummaryProduct = styled.div<{ isMobile?: boolean }>`
  display: ${({ isMobile }) => (isMobile ? 'flex' : 'grid')};
  grid-template-columns: ${({ isMobile }) => (isMobile ? 'none' : '3fr 0.8fr 1fr 1fr 1fr')};
  gap: ${({ isMobile }) => (isMobile ? '8px' : '24px')};
  align-items: ${({ isMobile }) => (isMobile ? 'flex-start' : 'center')};
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
`

const ProductInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 36px;
`

const ProductQuantity = styled.span`
  font-size: 14px;
  color: #4a4a4a;
  margin-left: 12px;
`

const ProductFlavor = styled.span`
  font-size: 13px;
  color: #4a4a4a;
`

const ProductUnitPrice = styled.div`
  font-size: 14px;
  color: #4a4a4a;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 0;
  align-items: flex-start;
`

const OldPrice = styled.div`
  font-size: 11px;
  color: #999;
  display: flex;
  gap: 4px;
  align-items: center;
  margin-left: 0;
`

const DiscountValue = styled.span`
  color: rgba(72, 183, 145, 0.94) !important;
  font-weight: 600;
  font-size: 10px;
`

const StrikedPrice = styled.span`
  text-decoration: line-through !important;
  font-size: 10px !important;
`

const ProductTotalPrice = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1c1c1c;
  margin-left: 26px;
`

const SummaryProductImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
`

const SummaryProductName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1c1c1c;
`

const MobileProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding-left: 0;
  margin-top: 4px;
`

const MobileDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #4a4a4a;
  gap: 8px;
  span:first-child {
    color: #999;
    min-width: unset;
    display: inline-block;
    text-align: left;
  }
  span:last-child {
    text-align: right;
    flex: 1;
  }
`

export default OrderSummary
